/* BEGIN::Added.by.HJSeo.2026.08.10. */
/**
 * ABAP 상세 > HANA DB 화면(Mockup) 메시지.
 *
 * 기존 상세화면들과 동일한 규칙을 따른다.
 *  - 화면 제목/탭명은 다국어 처리한다(본 파일).
 *  - 그리드 컬럼 라벨은 영문 원어를 그대로 쓴다(components/motlet/settings/grid.js 와 동일).
 *  - 지표명은 HANA 모니터링 뷰의 용어를 그대로 쓰고, 한국어/일본어는 설명형으로 보조한다.
 */
export default {
  'hanadb.related': {
    ko: '연관 지표',
    ja: '関連指標',
    en: 'Related metrics',
  },
  /* -------------------------------------------------------------- 카테고리 탭 */
  // 첫화면 A안/B안 비교용. 하나를 고르고 나면 나머지 탭은 삭제한다.
  /*
   * 이 탭은 세션·스레드보다 넓다. 서비스 상태·표준 Alert·파라미터·라이선스가 같이 들어 있고,
   * 정작 세션은 그리드 없이 차트 하나뿐이다.
   * 요약 스트립의 첫 타일(서비스)이 여기로 들어오므로 '서비스'를 앞에 세운다.
   * 다른 탭과 같은 "대상 이름" 작명은 그대로 두었다.
   * ('종합 상황'류는 상단 요약 스트립·보류 중인 A/B안 탭 이름과 겹쳐서 피했다.)
   */
  'hanadb.cat.overview': {
    ko: '서비스 · 세션',
    ja: 'サービス・セッション',
    en: 'Services & Sessions',
  },
  'hanadb.cat.memory': {
    ko: '메모리 · 테이블',
    ja: 'メモリ・テーブル',
    en: 'Memory & Tables',
  },
  'hanadb.cat.storage': {
    ko: '저장소 · 영속성',
    ja: 'ストレージ・永続化',
    en: 'Storage & Persistence',
  },
  'hanadb.cat.dlm': {
    ko: 'DLM · 아카이빙',
    ja: 'DLM・アーカイブ',
    en: 'DLM & Archiving',
  },
  /* --------------------------------------------------- 상태 요약(아침 점검 8종) */
  'hanadb.health.service': {
    ko: '서비스',
    ja: 'サービス',
    en: 'Services',
  },
  'hanadb.health.backup': {
    ko: '백업',
    ja: 'バックアップ',
    en: 'Backup',
  },
  'hanadb.health.log': {
    ko: '로그 볼륨',
    ja: 'ログボリューム',
    en: 'Log Volume',
  },
  'hanadb.health.memory': {
    ko: '메모리',
    ja: 'メモリ',
    en: 'Memory',
  },
  'hanadb.health.alert': {
    ko: '알림',
    ja: 'アラート',
    en: 'Alerts',
  },
  'hanadb.health.repl': {
    ko: '복제',
    ja: 'レプリケーション',
    en: 'Replication',
  },
  // 메모리·로그 볼륨과 같은 "사용률" 방향으로 통일했다(여유율은 desc/툴팁에 남김).
  'hanadb.health.disk': {
    ko: '디스크 사용',
    ja: 'ディスク使用',
    en: 'Disk Used',
  },
  // 요약 스트립에서는 빠졌지만 첫화면 A안/B안(검토 중) 패널이 아직 참조한다.
  /*
   * SAP·HANA 에서 쓰는 표현(long running statement/thread)을 그대로 쓴다.
   * 대상 이름인 'Thread' 로 두면 같은 탭의 Thread Usage 차트(스레드 개수)와 헷갈리고,
   * 이 타일은 개수가 아니라 "비정상적으로 오래 도는 게 있나"를 보는 자리다.
   * 값(초)과 desc(SAP 사용자·T-code)가 바로 아래에서 대상을 알려준다.
   */
  'hanadb.health.longthread': {
    ko: 'Long Running',
    ja: '長時間実行',
    en: 'Long Running',
  },
  'hanadb.unit.case': {
    ko: '건',
    ja: '件',
    en: 'cases',
  },
  'hanadb.unit.blocking': {
    ko: '건 차단',
    ja: '件ブロック',
    en: ' blocked',
  },
  /* ------------------------------------------------------------------ 차트 제목 */
  'hanadb.title.trend': {
    ko: '24시간 종합 추이',
    ja: '24時間の総合推移',
    en: '24h Trend',
  },
  'hanadb.title.events': {
    ko: '최근 이벤트 (24h)',
    ja: '最近のイベント (24h)',
    en: 'Recent Events (24h)',
  },
  'hanadb.title.resource': {
    ko: '자원 사용률',
    ja: 'リソース使用率',
    en: 'Resource Usage',
  },
  'hanadb.title.expsql': {
    ko: '실행 중 부하 SQL Top-5',
    ja: '実行中の負荷SQL Top-5',
    en: 'Running Expensive SQL Top-5',
  },
  'hanadb.title.sessions': {
    ko: 'Sessions',
    ja: 'セッション',
    en: 'Sessions',
  },
  'hanadb.title.expsqlcnt': {
    ko: 'Expensive SQL 건수',
    ja: '負荷SQL件数',
    en: 'Expensive SQL Count',
  },
  'hanadb.title.cpu': {
    ko: 'CPU Usage',
    ja: 'CPU使用率',
    en: 'CPU Usage',
  },
  'hanadb.title.thread': {
    ko: 'Thread Usage',
    ja: 'スレッド使用状況',
    en: 'Thread Usage',
  },
  'hanadb.title.conn': {
    ko: 'Connections',
    ja: 'コネクション',
    en: 'Connections',
  },
  'hanadb.title.blocked': {
    ko: 'Blocked Transactions',
    ja: 'ブロックトランザクション',
    en: 'Blocked Transactions',
  },
  'hanadb.title.memory': {
    ko: 'Memory (Allocation Limit)',
    ja: 'メモリ (Allocation Limit)',
    en: 'Memory (Allocation Limit)',
  },
  'hanadb.title.csmem': {
    ko: 'Table Memory (CS/RS)',
    ja: 'テーブルメモリ (CS/RS)',
    en: 'Table Memory (CS/RS)',
  },
  'hanadb.title.gc': {
    ko: 'GC Status (MVCC)',
    ja: 'GC状態 (MVCC)',
    en: 'GC Status (MVCC)',
  },
  'hanadb.title.growth': {
    ko: 'Table Growth',
    ja: 'テーブル増加推移',
    en: 'Table Growth',
  },
  /*
   * COL-06c. 최근 이벤트 그리드의 'Lock wait' 과 다른 지표다.
   *   Lock wait          누가 얼마나 막혔나 (사건)  COL-06b
   *   Record Lock Count  몇 개가 잠겨 있나 (수준)   COL-06c
   * 이름이 겹치면 "락 46개인데 왜 이벤트가 없나" 로 읽힌다. 구분해서 쓴다.
   */
  'hanadb.title.recordlock': {
    ko: 'Record Lock Count',
    ja: 'レコードロック件数',
    en: 'Record Lock Count',
  },
  'hanadb.title.unload': {
    ko: 'Table Unload',
    ja: 'テーブルアンロード',
    en: 'Table Unload',
  },
  'hanadb.title.log': {
    ko: 'Log Volume',
    ja: 'ログボリューム',
    en: 'Log Volume',
  },
  /*
   * 종전 'Delta Merge Queue' 였으나 delta merge 에는 큐 지표가 없다(2026-09-04 확인).
   * 차트가 Admission Control 대기 + merge 실행 두 계열로 바뀌어 제목도 바꾼다.
   */
  /* Admission Queued 계열을 뺀 뒤 제목도 되돌렸다(2026-10-01). StoragePanel.deltaSeries 주석 참조. */
  'hanadb.title.delta': {
    ko: 'Delta Merge',
    ja: 'デルタマージ',
    en: 'Delta Merge',
  },
  'hanadb.title.savepoint': {
    ko: 'Savepoint',
    ja: 'セーブポイント',
    en: 'Savepoint',
  },
  'hanadb.title.volumeio': {
    ko: 'Disk I/O',
    ja: 'ディスクI/O',
    en: 'Disk I/O',
  },
  'hanadb.title.reclaim': {
    ko: 'Data Volume Reclaim Gap',
    ja: 'データボリューム再利用ギャップ',
    en: 'Data Volume Reclaim Gap',
  },
  'hanadb.title.repl': {
    ko: 'System Replication',
    ja: 'システムレプリケーション',
    en: 'System Replication',
  },
  'hanadb.title.archive': {
    ko: 'Archive Directory',
    ja: 'アーカイブディレクトリ',
    en: 'Archive Directory',
  },
  'hanadb.title.nse': {
    ko: 'NSE Buffer Cache',
    ja: 'NSEバッファキャッシュ',
    en: 'NSE Buffer Cache',
  },
  'hanadb.title.aging': {
    ko: 'Data Aging',
    ja: 'データエージング',
    en: 'Data Aging',
  },
  /* ------------------------------------------------------- 좌측 요약(도넛/게이지) */
  'hanadb.label.thread': {
    ko: 'Threads',
    ja: 'Threads',
    en: 'Threads',
  },
  'hanadb.label.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
  'hanadb.label.conn': {
    ko: 'Conn.',
    ja: 'Conn.',
    en: 'Conn.',
  },
  'hanadb.label.store': {
    ko: 'Store (MB)',
    ja: 'Store (MB)',
    en: 'Store (MB)',
  },
  'hanadb.label.cs': {
    ko: 'CS',
    ja: 'CS',
    en: 'CS',
  },
  'hanadb.label.rs': {
    ko: 'RS',
    ja: 'RS',
    en: 'RS',
  },
  'hanadb.label.backup': {
    ko: 'Backup 24h',
    ja: 'Backup 24h',
    en: 'Backup 24h',
  },
  'hanadb.label.logvolume': {
    ko: 'Log',
    ja: 'Log',
    en: 'Log',
  },
  'hanadb.label.datavolume': {
    ko: 'Data',
    ja: 'Data',
    en: 'Data',
  },
  'hanadb.label.temperature': {
    ko: 'DLM (%)',
    ja: 'DLM (%)',
    en: 'DLM (%)',
  },
  'hanadb.label.archive': {
    ko: 'Archive',
    ja: 'Archive',
    en: 'Archive',
  },
  'hanadb.label.buffer': {
    ko: 'Hit',
    ja: 'Hit',
    en: 'Hit',
  },
  /* --------------------------------------------------------------- 하단 그리드 탭 */
  /*
   * '최근 이벤트' 에서 바꿨다(2026-10-01). 두 가지가 걸렸다.
   *   '최근' 이 시간 범위를 약속하는데 갈래마다 다르다(HANA Alert 는 7일 집계가 섞인다).
   *   나머지 일곱 탭은 전부 원천 이름이라 이것만 파생물인 것이 이름에 안 드러났다.
   * 지금 이름은 남는 Level 과 정확히 같다 - Info 를 안 올리므로 경고와 오류뿐이다.
   */
  'hanadb.tab.events': {
    ko: '경고·오류',
    ja: '警告・エラー',
    en: 'Warnings & Errors',
  },
  'hanadb.tab.expsql': {
    ko: 'Expensive SQL',
    ja: '負荷SQL',
    en: 'Expensive SQL',
  },
  'hanadb.tab.services': {
    ko: 'Services',
    ja: 'サービス',
    en: 'Services',
  },
  'hanadb.tab.threads': {
    ko: 'Service Threads',
    ja: 'サービススレッド',
    en: 'Service Threads',
  },
  'hanadb.tab.blocked': {
    ko: 'Blocked Transactions',
    ja: 'ブロックトランザクション',
    en: 'Blocked Transactions',
  },
  'hanadb.tab.alerts': {
    ko: 'HANA Alerts',
    ja: 'HANAアラート',
    en: 'HANA Alerts',
  },
  'hanadb.tab.params': {
    ko: 'Parameter Changes',
    ja: 'パラメータ変更履歴',
    en: 'Parameter Changes',
  },
  'hanadb.tab.license': {
    ko: 'License',
    ja: 'ライセンス',
    en: 'License',
  },
  'hanadb.tab.cstables': {
    ko: 'Column Store Top-N',
    ja: 'カラムストア Top-N',
    en: 'Column Store Top-N',
  },
  'hanadb.tab.rstables': {
    ko: 'Row Store Top-N',
    ja: 'ロウストア Top-N',
    en: 'Row Store Top-N',
  },
  'hanadb.tab.oom': {
    ko: 'OOM Events',
    ja: 'OOMイベント',
    en: 'OOM Events',
  },
  'hanadb.tab.unloads': {
    ko: 'Table Unloads',
    ja: 'テーブルアンロード',
    en: 'Table Unloads',
  },
  'hanadb.tab.growth': {
    ko: 'Table Growth',
    ja: 'テーブル増加',
    en: 'Table Growth',
  },
  'hanadb.tab.logseg': {
    ko: 'Log Segments',
    ja: 'ログセグメント',
    en: 'Log Segments',
  },
  'hanadb.tab.delta': {
    ko: 'Delta Merge',
    ja: 'デルタマージ',
    en: 'Delta Merge',
  },
  'hanadb.tab.admission': {
    ko: 'Admission Control',
    ja: 'アドミッション制御',
    en: 'Admission Control',
  },
  'hanadb.tab.backup': {
    ko: 'Backup Catalog',
    ja: 'バックアップカタログ',
    en: 'Backup Catalog',
  },
  'hanadb.tab.replication': {
    ko: 'Replication',
    ja: 'レプリケーション',
    en: 'Replication',
  },
  'hanadb.tab.savepoint': {
    ko: 'Savepoints',
    ja: 'セーブポイント',
    en: 'Savepoints',
  },
  'hanadb.tab.volumeio': {
    ko: 'Disk I/O',
    ja: 'ディスクI/O',
    en: 'Disk I/O',
  },
  'hanadb.tab.datavolume': {
    ko: 'Data Volumes',
    ja: 'データボリューム',
    en: 'Data Volumes',
  },
  'hanadb.tab.archivedir': {
    ko: 'Archive Directory',
    ja: 'アーカイブディレクトリ',
    en: 'Archive Directory',
  },
  'hanadb.tab.aging': {
    ko: 'Data Aging',
    ja: 'データエージング',
    en: 'Data Aging',
  },
  'hanadb.tab.sara': {
    ko: 'SARA Job Log',
    ja: 'SARAジョブログ',
    en: 'SARA Job Log',
  },
  'hanadb.tab.dlmjobs': {
    ko: 'DLM Background Jobs',
    ja: 'DLMバックグラウンドジョブ',
    en: 'DLM Background Jobs',
  },
  'hanadb.tab.nse': {
    ko: 'NSE Paged Tables',
    ja: 'NSEページドテーブル',
    en: 'NSE Paged Tables',
  },
  'hanadb.tab.contentrepo': {
    ko: 'Content Repository',
    ja: 'コンテンツリポジトリ',
    en: 'Content Repository',
  },
  'hanadb.tab.remote': {
    ko: 'Remote Sources',
    ja: 'リモートソース',
    en: 'Remote Sources',
  },
  /* ------------------------------------------------------------- 보기 전환 툴팁 */
  // 화면에 쓰는 용어 그대로 둔다(Threads · Data Aging 과 같은 취급).
  'hanadb.view.grid': {
    ko: 'Grid',
    ja: 'Grid',
    en: 'Grid',
  },
  'hanadb.view.treemap': {
    ko: 'Treemap',
    ja: 'Treemap',
    en: 'Treemap',
  },
  /* ----------------------------------------------------- 그리드 컬럼 라벨
   * 규칙 - HANA·SAP 가 부르는 이름(뷰 컬럼명·기능명)은 영문을 그대로 두고,
   * 우리가 붙인 서술어만 번역한다. 판별은 '이 단어로 SAP 문서·SQL·Cockpit 을
   * 검색할 수 있나' 로 한다 - 검색되는 말을 번역하면 교차 참조가 끊긴다.
   *   영문 유지  Allocated · Used · Load unit · Page loadable · Last merge ...
   *              (ALLOCATED_*_SIZE · USED_*_SIZE 처럼 뷰 컬럼과 1:1 이다)
   *   번 역      Fragmentation · Current size · Occurred at ...
   *              (HANA 컬럼이 아니라 우리가 계산하거나 붙인 말이다)
   *
   * 여기 없는 라벨은 MockGrid 가 영문 원문을 그대로 쓴다($te 로 판별).
   * 그래서 '영문 유지' 그룹은 키를 만들지 않으며 mock.js 는 손대지 않는다.
   */
  'hanadb.col.occurred_at': {
    ko: '발생 시각',
    ja: '発生時刻',
    en: 'Occurred at',
  },
  'hanadb.col.detected_at': {
    ko: '감지 시각',
    ja: '検知時刻',
    en: 'Detected at',
  },
  'hanadb.col.started_at': {
    ko: '시작 시각',
    ja: '開始時刻',
    en: 'Started at',
  },
  'hanadb.col.start_time': {
    ko: '시작 시각',
    ja: '開始時刻',
    en: 'Start time',
  },
  'hanadb.col.end_time': {
    ko: '종료 시각',
    ja: '終了時刻',
    en: 'End time',
  },
  'hanadb.col.changed_at': {
    ko: '변경 시각',
    ja: '変更時刻',
    en: 'Changed at',
  },
  'hanadb.col.written_at': {
    ko: '기록 시각',
    ja: '記録時刻',
    en: 'Written at',
  },
  'hanadb.col.expires_at': {
    ko: '만료일',
    ja: '有効期限',
    en: 'Expires at',
  },
  'hanadb.col.state': {
    ko: '상태',
    ja: '状態',
    en: 'State',
  },
  'hanadb.col.rating': {
    ko: '심각도',
    ja: '重要度',
    en: 'Rating',
  },
  'hanadb.col.reason': {
    ko: '사유',
    ja: '理由',
    en: 'Reason',
  },
  'hanadb.col.comment': {
    ko: '비고',
    ja: '備考',
    en: 'Comment',
  },
  'hanadb.col.phase': {
    ko: '단계',
    ja: 'フェーズ',
    en: 'Phase',
  },
  'hanadb.col.duration': {
    ko: '소요 시간',
    ja: '所要時間',
    en: 'Duration',
  },
  'hanadb.col.duration_s': {
    ko: '소요 시간(초)',
    ja: '所要時間(秒)',
    en: 'Duration (s)',
  },
  'hanadb.col.permanent': {
    ko: '영구',
    ja: '恒久',
    en: 'Permanent',
  },
  'hanadb.col.version': {
    ko: '버전',
    ja: 'バージョン',
    en: 'Version',
  },
  'hanadb.col.changed_by': {
    ko: '변경자',
    ja: '変更者',
    en: 'Changed by',
  },
  'hanadb.col.owner_program': {
    ko: '소유 프로그램',
    ja: '所有プログラム',
    en: 'Owner program',
  },
  'hanadb.col.root_program': {
    ko: '최상위 프로그램',
    ja: '最上位プログラム',
    en: 'Root program',
  },
  'hanadb.col.program_source': {
    ko: '프로그램 / 소스',
    ja: 'プログラム / ソース',
    en: 'Program / source',
  },
  'hanadb.col.depth': {
    ko: '깊이',
    ja: '深さ',
    en: 'Depth',
  },
  'hanadb.col.table_name': {
    ko: '테이블명',
    ja: 'テーブル名',
    en: 'Table name',
  },
  'hanadb.col.column_name': {
    ko: '컬럼명',
    ja: 'カラム名',
    en: 'Column name',
  },
  'hanadb.col.records': {
    ko: '레코드 수',
    ja: 'レコード数',
    en: 'Records',
  },
  'hanadb.col.statements': {
    ko: '문장 수',
    ja: 'ステートメント数',
    en: 'Statements',
  },
  'hanadb.col.documents': {
    ko: '문서 수',
    ja: 'ドキュメント数',
    en: 'Documents',
  },
  'hanadb.col.files': {
    ko: '파일 수',
    ja: 'ファイル数',
    en: 'Files',
  },
  'hanadb.col.file_size': {
    ko: '파일 크기',
    ja: 'ファイルサイズ',
    en: 'File size',
  },
  'hanadb.col.size': {
    ko: '크기',
    ja: 'サイズ',
    en: 'Size',
  },
  'hanadb.col.memory_size': {
    ko: '메모리 크기',
    ja: 'メモリサイズ',
    en: 'Memory size',
  },
  'hanadb.col.disk_size': {
    ko: '디스크 크기',
    ja: 'ディスクサイズ',
    en: 'Disk size',
  },
  'hanadb.col.current_size': {
    ko: '현재 크기',
    ja: '現在サイズ',
    en: 'Current size',
  },
  'hanadb.col.previous_size': {
    ko: '이전 크기',
    ja: '以前サイズ',
    en: 'Previous size',
  },
  'hanadb.col.growth': {
    ko: '증가량',
    ja: '増加量',
    en: 'Growth',
  },
  'hanadb.col.growth_rate_pct': {
    ko: '증가율 (%)',
    ja: '増加率 (%)',
    en: 'Growth rate (%)',
  },
  'hanadb.col.fragmentation_pct': {
    ko: '단편화(%)',
    ja: '断片化(%)',
    en: 'Fragmentation (%)',
  },
  'hanadb.col.free_rate_pct': {
    ko: '여유 비율(%)',
    ja: '空き率(%)',
    en: 'Free rate (%)',
  },
  'hanadb.col.gap_rate_pct': {
    ko: '격차 비율(%)',
    ja: 'ギャップ率(%)',
    en: 'Gap rate (%)',
  },
  'hanadb.col.free': {
    ko: '여유',
    ja: '空き',
    en: 'Free',
  },
  'hanadb.col.path': {
    ko: '경로',
    ja: 'パス',
    en: 'Path',
  },
  'hanadb.col.purpose': {
    ko: '용도',
    ja: '用途',
    en: 'Purpose',
  },
  'hanadb.col.partition': {
    ko: '파티션',
    ja: 'パーティション',
    en: 'Partition',
  },
  'hanadb.col.partitions': {
    ko: '파티션 수',
    ja: 'パーティション数',
    en: 'Partitions',
  },
  'hanadb.col.requested': {
    ko: '요청 크기',
    ja: '要求サイズ',
    en: 'Requested',
  },
  'hanadb.col.sample': {
    ko: '표본',
    ja: 'サンプル',
    en: 'Sample',
  },
  'hanadb.col.interval_s': {
    ko: '간격(초)',
    ja: '間隔(秒)',
    en: 'Interval (s)',
  },
  'hanadb.col.session': {
    ko: '세션',
    ja: 'セッション',
    en: 'Session',
  },
  'hanadb.col.temperature': {
    ko: '온도',
    ja: '温度',
    en: 'Temperature',
  },
  'hanadb.col.product': {
    ko: '제품',
    ja: '製品',
    en: 'Product',
  },
  'hanadb.col.before': {
    ko: '변경 전',
    ja: '変更前',
    en: 'Before',
  },
  'hanadb.col.after': {
    ko: '변경 후',
    ja: '変更後',
    en: 'After',
  },
  'hanadb.col.queued': {
    ko: '대기',
    ja: '待機',
    en: 'Queued',
  },
  'hanadb.col.queue_limit': {
    ko: '대기 한도',
    ja: '待機上限',
    en: 'Queue limit',
  },
  'hanadb.col.enqueued': {
    ko: '투입',
    ja: '投入',
    en: 'Enqueued',
  },
  'hanadb.col.rejected': {
    ko: '반려',
    ja: '却下',
    en: 'Rejected',
  },
  'hanadb.col.timed_out': {
    ko: '시간 초과',
    ja: 'タイムアウト',
    en: 'Timed out',
  },
  'hanadb.col.admitted': {
    ko: '허용',
    ja: '許可',
    en: 'Admitted',
  },
  'hanadb.col.wait_s': {
    ko: '대기(초)',
    ja: '待機(秒)',
    en: 'Wait (s)',
  },
  'hanadb.col.avg_wait_ms': {
    ko: '평균 대기(ms)',
    ja: '平均待機(ms)',
    en: 'Avg wait (ms)',
  },
  'hanadb.col.max_wait_ms': {
    ko: '최대 대기(ms)',
    ja: '最大待機(ms)',
    en: 'Max wait (ms)',
  },
  'hanadb.col.remote_user': {
    ko: '원격 사용자',
    ja: 'リモートユーザー',
    en: 'Remote user',
  },
  'hanadb.col.connection_info': {
    ko: '접속 정보',
    ja: '接続情報',
    en: 'Connection info',
  },
  /* ------------------------------------------------------- 트리맵 라벨
   * 그리드 컬럼과 같은 규칙이다 - HANA 원어(Allocated · Page loadable ·
   * Delta rate …)는 세 로케일 모두 영문으로 두고, 우리가 붙인 말만 번역한다.
   */
  /* 트리맵 제목의 '면적 ...' 앞머리. 무엇이 타일 크기인지 알린다. */
  'hanadb.map.area': {
    ko: '면적',
    ja: '面積',
    en: 'Area',
  },
  'hanadb.map.area.memory': {
    ko: '메모리',
    ja: 'メモリ',
    en: 'Memory',
  },
  'hanadb.map.area.allocated': {
    ko: 'Allocated',
    ja: 'Allocated',
    en: 'Allocated',
  },
  'hanadb.map.area.disk': {
    ko: '디스크',
    ja: 'ディスク',
    en: 'Disk',
  },
  'hanadb.map.color.resident': {
    ko: '메모리 상주',
    ja: 'メモリ常駐',
    en: 'Resident',
  },
  'hanadb.map.color.fragmentation': {
    ko: '단편화',
    ja: '断片化',
    en: 'Fragmentation',
  },
  'hanadb.map.color.growth': {
    ko: '증감',
    ja: '増減',
    en: 'Growth',
  },
  'hanadb.map.cs.p1': {
    ko: '10% 미만 · 대부분 디스크',
    ja: '10%未満 · 大半がディスク',
    en: 'under 10% · mostly on disk',
  },
  'hanadb.map.cs.p2': {
    ko: '10~90%',
    ja: '10~90%',
    en: '10-90%',
  },
  'hanadb.map.cs.p3': {
    ko: '90% 이상 · 전량 메모리',
    ja: '90%以上 · 全量メモリ',
    en: '90%+ · fully in memory',
  },
  'hanadb.map.rs.p1': {
    ko: '5% 미만',
    ja: '5%未満',
    en: 'under 5%',
  },
  'hanadb.map.rs.p2': {
    ko: '5~10%',
    ja: '5~10%',
    en: '5-10%',
  },
  'hanadb.map.rs.p3': {
    ko: '10~30%',
    ja: '10~30%',
    en: '10-30%',
  },
  'hanadb.map.rs.p4': {
    ko: '30% 이상 · 재구성 권고',
    ja: '30%以上 · 再編成推奨',
    en: '30%+ · reorg recommended',
  },
  'hanadb.map.growth.p1': {
    ko: '-1% 이하',
    ja: '-1%以下',
    en: '-1% or less',
  },
  'hanadb.map.growth.p2': {
    ko: '감소',
    ja: '減少',
    en: 'decreasing',
  },
  'hanadb.map.growth.p3': {
    ko: '2% 미만',
    ja: '2%未満',
    en: 'under 2%',
  },
  'hanadb.map.growth.p4': {
    ko: '2~5%',
    ja: '2~5%',
    en: '2-5%',
  },
  'hanadb.map.growth.p5': {
    ko: '5% 이상 · 빠른 증가',
    ja: '5%以上 · 急増',
    en: '5%+ · growing fast',
  },
  'hanadb.map.tip.pageloadable': {
    ko: 'Page loadable',
    ja: 'Page loadable',
    en: 'Page loadable',
  },
  'hanadb.map.tip.deltarate': {
    ko: 'Delta rate',
    ja: 'Delta rate',
    en: 'Delta rate',
  },
  'hanadb.map.tip.deltamemory': {
    ko: 'Delta memory',
    ja: 'Delta memory',
    en: 'Delta memory',
  },
  'hanadb.map.tip.used': {
    ko: 'Used',
    ja: 'Used',
    en: 'Used',
  },
  'hanadb.map.tip.records': {
    ko: '레코드 수',
    ja: 'レコード数',
    en: 'Records',
  },
  'hanadb.map.tip.previous': {
    ko: '이전 크기',
    ja: '以前サイズ',
    en: 'Previous size',
  },
};
/* FINISH::Added.by.HJSeo.2026.08.10. */
